const startsWithSubDirectory = (
  urlPath: string,
  subDirectory: string,
  matchOnlySubpages: boolean = false,
) => {
  const prefix = `${subDirectory}/`;
  if (urlPath === subDirectory || urlPath === prefix) {
    return !matchOnlySubpages;
  }
  return urlPath.startsWith(prefix);
};

export default startsWithSubDirectory;
